import {connect} from 'react-redux';

import {ChannelTypesEnum} from '../../../../libs/shared/core/src/models/api/channelCommonTypes';
import {
  createSelector,
  makeMapDispatchToProps,
  makeMapStateToProps,
} from '../../../../srcCommon/helpers/reselectHelpers';
import {buildChannelSettingsPath} from '../../../helpers/models/channelHelpers';
import {SettingsResourcePagesEnum, SettingsRootPagesEnum} from '../../../models/url/models/types';
import {buildSettingsPath} from '../../../models/url/settingsUrlHelpers';
import {ThunkAction} from '../../../store/appThunk';
import {getUserOwnedChannels} from '../../../store/data/channels/channelsSelectors';
import {getUserNamespace} from '../../../store/data/teammates/teammatesSelectors';
import {navigateToLinkAction} from '../../../store/stateless/navigationActions';
import {CalendarsEmpty} from './calendarsEmpty';

/*
 * Selectors.
 */

const getReAuthChannel = createSelector([getUserOwnedChannels], (userOwnedChannels) =>
  userOwnedChannels.find((c) => c.behaviors.isMissingCalendarScopes),
);

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps()(() => ({
  reAuthChannel: getReAuthChannel,
}));

const mapDispatchToProps = makeMapDispatchToProps()(() => ({
  onGoToReAuthChannelSettingsClick: (): ThunkAction => (dispatch, getState) => {
    const state = getState();
    const reAuthChannel = getReAuthChannel(state);
    if (!reAuthChannel) {
      return;
    }

    const settingsPath = buildChannelSettingsPath(reAuthChannel);
    dispatch(navigateToLinkAction(settingsPath));
  },
  onAddGoogleChannelClick: (): ThunkAction => (dispatch, getState) => {
    const userNamespace = getUserNamespace(getState());

    dispatch(
      navigateToLinkAction(
        buildSettingsPath({
          namespace: userNamespace,
          rootPage: SettingsRootPagesEnum.CHANNELS,
          resourcePage: SettingsResourcePagesEnum.NEW,
          channelType: ChannelTypesEnum.GMAIL,
        }),
      ),
    );
  },
  onAddOffice365ChannelClick: (): ThunkAction => (dispatch, getState) => {
    const userNamespace = getUserNamespace(getState());

    dispatch(
      navigateToLinkAction(
        buildSettingsPath({
          namespace: userNamespace,
          rootPage: SettingsRootPagesEnum.CHANNELS,
          resourcePage: SettingsResourcePagesEnum.NEW,
          channelType: ChannelTypesEnum.OFFICE365,
        }),
      ),
    );
  },
}));

export const CalendarsEmptyContainer = connect(mapStateToProps, mapDispatchToProps)(CalendarsEmpty);
